export default "__VITE_ASSET__bf52a1fd__"